// DS1.15.5
import React from 'react';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import UserAvatar from '../Avatar';
import UserLink from '../Link';
import { useTranslation } from 'react-i18next';
import s from './UserIdentitySecondary.scss';
/**
 * Used for the non-creator owner ident (the person who purchased the deviation)
 */ const UserIdentitySecondary = ({ size, user, className, showSymbol })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Flex, {
        className: classnames(s[size], s['root'], className),
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        user: user,
        className: s['avatar'],
        size: size === 'small' ? 24 : 32
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['details']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['owner']
    }, t('user.identity.owner.prefix')), /*#__PURE__*/ React.createElement(UserLink, {
        user: user,
        showSymbol: showSymbol,
        className: s['userlink']
    })));
};
UserIdentitySecondary.displayName = 'UserIdentitySecondary';
export default UserIdentitySecondary;
